export const ICP_TRANSFER_TYPE_FORMAT: { [key: string]: string } = {
  TRANSACTION: "transfer",
};

export const CYCLES_MINTING_CANISTER_ID = "rkp4c-7iaaa-aaaaa-aaaca-cai";

export { LEDGER_CANISTER_ID } from "@icpswap/constants";
